import React, { useState } from 'react';

import UserManagementTab from './UserManagementTab';
import NotificationsTab from './NotificationsTab';
import ReviewsTab from './ReviewsTab';
import './Dashboard.css';

function Dashboard() {
  const [activeTab, setActiveTab] = useState('users');

  // Function to handle tab switching
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="dashboard-page">
      <div className="dashboard-header">
      <h2>Admin Dashboard</h2>
        {/* Tabs */}
        <div className="dashboard-tabs">
          <button
            className={`dashboard-tab ${activeTab === 'users' ? 'active' : ''}`}
            onClick={() => handleTabClick('users')}
          >
            Users
          </button>
          <button
            className={`dashboard-tab ${activeTab === 'notifications' ? 'active' : ''}`}
            onClick={() => handleTabClick('notifications')}
          >
            Notifications
          </button>
          <button
            className={`dashboard-tab ${activeTab === 'reviews' ? 'active' : ''}`}
            onClick={() => handleTabClick('reviews')}
          >
            Reviews
          </button>
        </div>
      </div>

      {/* Tab Content */}
      <div className="dashboard-tab-content">
        {activeTab === 'users' && <UserManagementTab />}
        {activeTab === 'notifications' && <NotificationsTab />}
        {activeTab === 'reviews' && <ReviewsTab />}
      </div>
    </div>
  );
}

export default Dashboard;

